import navigation from './components/navigation'
import skipLinks from './components/skip-links';
import tables from './components/tables';
import accordions from './components/accordions';
import dialogs from './components/dialogs';
import tabs from './components/tablist';

tabs( document.querySelectorAll( '.tabs' ) );
skipLinks( document.getElementById( 'skip-to-content' ) );
navigation( document.querySelector( '.header__nav' ) )
tables( document.querySelectorAll( 'table' ) );
accordions( document.querySelectorAll( 'details' ) );
dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );

